// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedChinRest_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.01097 7C5.00367 7.1563 5 7.31423 5 7.47368V8L2.18896 11.7368C1.75137 12.4737 2.04241 13 3.39234 13H5V16.5C5 18.5 6 20 8.02799 20H13L15 24H24L18.3829 14C19.8051 12.5263 21 10.2105 21 8C21 3 16.851 0 12.1851 0C8.58436 0 6.16491 2.01569 5.32642 5H3L2 7H5.01097ZM16.9437 12.6112L15.9103 13.682L20.5827 22H16.2361L14.2361 18H14V11L17 8.5V5H7.43271C7.66597 4.40423 7.98426 3.89705 8.36455 3.48534C9.17583 2.60704 10.4173 2 12.1851 2C16.067 2 19 4.4 19 8C19 9.56765 18.1032 11.4097 16.9437 12.6112ZM7.01362 7H15.5L12 10V18H8.02799C7.55726 18 7.3976 17.8528 7.31097 17.7453C7.17632 17.5782 7 17.1951 7 16.5V11H5.24595L7 8.66826V7.4743C7 7.3131 7.0046 7.15454 7.01362 7Z" class="svg-bg"/>
  <path d="M1 19H3.33238L5.13249 22.0002H9.33446L10.4892 24.0002H4.00011L1 19Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedChinRest is a generated icon component.
 */
let IconMedChinRest = IconMedChinRest_1 = class IconMedChinRest extends IconBaseElement {
    render() {
        return html `${IconMedChinRest_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedChinRest.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedChinRest = IconMedChinRest_1 = __decorate([
    customElement('zui-icon-med-chin-rest')
], IconMedChinRest);
export { IconMedChinRest };
